class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close(true));
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', () => this.close(false));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close(restoreFocus = true) {
    this.classList.remove('active');
    if (restoreFocus && this.activeElement) {
      removeTrapFocus(this.activeElement);
    } else {
      removeTrapFocus();
      if (document.activeElement && this.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    }
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  syncFromSectionHtml(sectionHtml) {
    if (!sectionHtml) return;

    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const sourceDrawer = parsed.querySelector('cart-drawer');
    const sourceInner =
      parsed.querySelector('cart-drawer .drawer__inner') || parsed.querySelector('.drawer__inner');
    const liveInner = this.querySelector('.drawer__inner');

    if (sourceInner && liveInner) {
      liveInner.innerHTML = sourceInner.innerHTML;
    }

    if (sourceDrawer) {
      this.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
    } else {
      this.classList.remove('is-empty');
    }
  }

  renderContents(parsedState) {
    if (parsedState.status) return;

    this.productId = parsedState.id;
    this.classList.remove('is-empty');

    const cartDrawerSection = parsedState.sections?.['cart-drawer'];
    if (cartDrawerSection) {
      this.syncFromSectionHtml(cartDrawerSection);
    }

    const cartIconSection = parsedState.sections?.['cart-icon-bubble'];
    if (cartIconSection) {
      const bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl) {
        bubbleEl.innerHTML = this.getSectionInnerHTML(cartIconSection, '.shopify-section');
      }
    }

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
